// @flow
import { TOGGLE_FAVOURITE_MARKETTYPE } from '../../actions/live/actions';
import { createToggleFavoritesReducer } from '../../../utils';

export const favouriteMarkettypes = createToggleFavoritesReducer(
  TOGGLE_FAVOURITE_MARKETTYPE
);
